module.exports = __webpack_public_path__ + "img/iphonama.bda4c944.png";